import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CurrencyService extends GenericService {
  constructor() {
    super('/currencies', axiosInstance);
  }
}

export default new CurrencyService(); 